import React, { useEffect, useState} from "react";
import { useTranslation } from 'react-i18next';
import cx from "classnames";
import { Switch, Route, Redirect, useHistory } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import AdminNavbar from "beaktShared/components/Navbars/AdminNavbar.js";
import Footer from "beaktShared/components/Footer/Footer.js";
import Sidebar from "beaktShared/components/Sidebar/Sidebar.js";
import routes_before from "beaktDay/routesday.js";
import styles from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.js";
import { SessionContext, getSessionCookie } from "beaktShared/services/session";
import { getTokenCookie, setTokenCookie } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApiLogin } from "beaktShared/services/crudeApiService";
import queryString from 'query-string';
import { Chat } from "beaktShared/constants/Chat";

var ps;

const useStyles = makeStyles(styles);

export default function Admin(props) {
  const history = useHistory();
  const { t } = useTranslation();

  const [routes, setroutes] = React.useState([]);
    
  const [session, setSession] = useState(getSessionCookie());  
  
  useEffect(() => {
    //getRoutesApi();
    Chat();
    routesToProfissional();
    validateToken("");    
  },[]);

  useEffect(() => {
    setInterval(()=> {    
      var token = getTokenCookie();
      if (token === null) {
        props.history.push("/auth/login");
        return false;
      }
    }, 3000);

    validateToken(history.location.pathname);
  },[history.location.pathname]);

  const validateToken = (activeRoute) => {
    if (session != null && !(session.tipoPerfil == 0 || session.tipoPerfil == 1 || session.tipoPerfil == 2 || (session.tipoPerfil == 4 && session.acessaTodosEstabelecimentos == true)))
    {
      props.history.push("/auth/login");
      return false;      
    }
    
    var token = getTokenCookie();
    if (session === null || token === null) {
      props.history.push("/auth/login");
    }
    
    if (token.expired)
      props.history.push("/auth/login");  
                     
    /*if (activeRoute != "" && activeRoute != "/adminday/home" && activeRoute != "/adminday/accessdenied")
    {
      if (session.tipoPerfil != 0 && session.tipoPerfil != 4){
        UseGetApiSimple("usuarios/checkpermission/" + session.id + "/" + activeRoute.replace("/adminday/", "")).then(result => {
          if (result.data != true)
            props.history.push("/adminday/accessdenied");      
        })        
      }
    }*/
  }

  const getRoutesApi = () =>
  {
    //if (session.tipoPerfil == 0 || session.tipoPerfil == 4)
      setroutes(routes_before);
    /*else{
      UseGetApiSimple("usuarios/getpermissoes/" + session.id, "").then(result => {      
        updateRoutes(routes_before, result.data);
      });    
    }*/   
  }
  const routesToProfissional = () =>
  {
    if(session.tipoPerfil===2)
    {
      var listFiltered = routes_before.filter(obj => {
          return (obj.path === '/agenda' || obj.path === '/user');
      });
      //console.log(routes_before)
      setroutes(listFiltered);
      return;
    }
    setroutes(routes_before);    
  }
  
  /*const updateRoutes = (listroutes, permissions) => {            
    let listfiltered = listroutes.filter((prop) => {
      return ((prop.collapse == null && permissions.filter((p) => ("/"+p.path) === prop.path).length > 0)
              || (prop.collapse == true && permissions.filter((p) => prop.views.filter((f) => f.path == ("/"+p.path)).length > 0).length > 0)
            )
    });
    setroutes(listfiltered);
  };*/ 

  const { ...rest } = props;
  // states and functions
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [miniActive, setMiniActive] = React.useState(false);
  // const [image] = React.useState(require("assets/img/sidebar-2.jpg"));
  const [color] = React.useState("blue");
  const [bgColor] = React.useState("black");
  // const [hasImage, setHasImage] = React.useState(true);
  
  const [logo, set_logo] = React.useState("");
  useEffect(() => {
    if(session != null)
      set_logo(process.env.REACT_APP_API_ENDPOINT + "anexos/" + session.logoPequeno);
  }, [session]);  

  // styles
  const classes = useStyles();
  const mainPanelClasses =
    classes.mainPanel +
    " " +
    cx({
      [classes.mainPanelSidebarMini]: miniActive,
      [classes.mainPanelWithPerfectScrollbar]:
        navigator.platform.indexOf("Win") > -1
    });
  // ref for main panel div
  const mainPanel = React.createRef();
  // effect instead of componentDidMount, componentDidUpdate and componentWillUnmount
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);

    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  });
  // functions for changeing the states from components
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const getActiveRoute = routes => {
    let activeRoute = "Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

  const getRoutes = routes => {
    
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }     
      
      return (
        <Route
          path={prop.layout + prop.path}
          component={prop.component}
          key={key}
        />
      );      
    });
  };
  const sidebarMinimize = () => {
    setMiniActive(!miniActive);
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };


  return (
    
  <SessionContext.Provider value={session}> 
  
    <div className={classes.wrapper}>
      <Sidebar
        history={props.history}
        routes={routes}
        logoText={"Agenda"}
        logo={logo}
        redirectlogo={"/adminday/agenda"}
        // image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        bgColor={bgColor}
        miniActive={miniActive}
        session={session}
        pathMainUrl="adminday"
        {...rest}
      />
      <div className={mainPanelClasses} ref={mainPanel}>
        <AdminNavbar
          sidebarMinimize={sidebarMinimize.bind(this)}
          miniActive={miniActive}
          brandText={getActiveRoute(routes) === "" ? "" :t('sidebar.'+getActiveRoute(routes))}
          handleDrawerToggle={handleDrawerToggle}  
          history={props.history}    
          pathMainUrl="adminday"
          {...rest}
        />
        
          <div className={classes.content}>
            <div className={classes.container}>
             
                <Switch>
                  {getRoutes(routes)}
                  {/* Comentei esse codigo, pois sempre que aperta o f5 encaminhava pra home.. ao inves de atualizar a tela atual
                  <Redirect from="/adminday" to="/adminday/agenda" />*/}
                </Switch>
            </div>
          </div>

        <Footer fluid /> 
      </div>
    </div>
    
    </SessionContext.Provider>
  );
}
